import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

// R1.7 (R-29): route-level role gate, extracted from App.js so it is reusable and
// unit-testable. Belt-and-suspenders for the role-masked nav — even if a user types
// an unauthorized URL directly, redirect home (which re-routes to the role's default
// landing) instead of rendering the page shell. Server-side Lambda RBAC remains the
// authoritative data gate; this only governs what the browser will render.
export default function ProtectedRoute({ allow, children }) {
  const { role } = useAuth();
  const r = String(role || "").toLowerCase();
  const ok = Array.isArray(allow) && allow.includes(r);
  if (!ok) return <Navigate to="/" replace />;
  return children;
}
